import script from "./AllServerGoldMoney.vue?vue&type=script&setup=true&lang=js"
export * from "./AllServerGoldMoney.vue?vue&type=script&setup=true&lang=js"

import "./AllServerGoldMoney.vue?vue&type=style&index=0&id=4776f537&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4776f537"]])

export default __exports__